import styled from 'styled-components/macro';
import { darkerGray, gradientBlue, newRed } from '../../config/colors';

export const TextWrapper = styled.div`
  color: ${darkerGray};
  font-size: ${({ size }) => size || '16px'};
  font-style: normal;
  font-weight: 600;
  line-height: 1;
`;

export const Asterisk = styled.span`
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  color: ${newRed};
`;

export const StyledLink = styled.a.attrs({
  target: '_blank',
  rel: 'noopener noreferrer',
})`
  color: ${gradientBlue};
`;
